import type { Group } from "../state/group";
import type { User } from "../state/user";
import { isNotEmpty } from "./stringUtil";
import type { Invite } from "../state/invite.ts";

export const getGroupsForUser = (user: User | Invite, groups: Group[]): Group[] => {
  const memberIds = new Set(user.groups.map((id) => id.toString()));
  return groups.filter((group) => memberIds.has(group.id.toString()));
};

// DEV-6760 Implementation needs to be improved based on requirements (still need to be made)
export const resolveInitials = (group: Group): string => (isNotEmpty(group.name) ? group.name[0] : "??");

export const resolveName = (group: Group): string => (isNotEmpty(group.name) ? group.name : "??");
